export default __webpack_public_path__ + "static/media/Frame.578ccd16.png";